module.exports = __webpack_public_path__ + "static/media/Close.3d2ecf4f.svg";